module.exports = __webpack_public_path__ + "static/media/send-otp.0c5c0a8c.png";